import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement, Filler } from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Registrar los componentes de ChartJS
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    PointElement,
    LineElement,
    Filler
);

function Grafica(props) {

    // Datos de las cartas con el mismo estilo que DasboardActividad
    const cardsData = [
        {
            title: 'COMERCIOS REGISTRADOS',
            value: props.totalp || 0,
            color: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            icon: 'fas fa-store fa-3x',
            iconColor: 'rgba(255,255,255,0.2)'
        },
        {
            title: 'CLASIFICADORES DE TASA',
            value: props.clasificadoresTasa || 0,
            color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            icon: 'fas fa-file-invoice fa-3x',
            iconColor: 'rgba(255,255,255,0.2)'
        },
        {
            title: 'COMERCIOS CON EXPENDIOS',
            value: props.totalExpendios || 0,
            color: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
            icon: 'fas fa-store-alt fa-3x',
            iconColor: 'rgba(255,255,255,0.2)'
        },
        {
            title: 'CLASIFICADORES EXPENDIOS',
            value: props.clasiexpe || 0,
            color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
            icon: 'fas fa-chart-line fa-3x',
            iconColor: 'rgba(255,255,255,0.2)'
        }
    ];

    // Datos para la gráfica de barras
    const chartData = {
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        datasets: [
            {
                label: 'Comercios Registrados',
                data: props.datosGrafica?.comercios || [65, 72, 88, 95, 102, 118, 135, 142, 158, 165, 178, 190],
                backgroundColor: 'rgba(30, 60, 114, 0.7)',
                borderColor: 'rgba(30, 60, 114, 1)',
                borderWidth: 1,
                borderRadius: 8,
            },
            {
                label: 'Comercios con Expendios',
                data: props.datosGrafica?.expendios || [45, 52, 68, 75, 82, 98, 115, 122, 138, 145, 158, 170],
                backgroundColor: 'rgba(250, 112, 154, 0.7)',
                borderColor: 'rgba(250, 112, 154, 1)',
                borderWidth: 1,
                borderRadius: 8,
            }
        ]
    };

    // Opciones de la gráfica
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: 12,
                        weight: 'bold'
                    },
                    usePointStyle: true,
                    boxWidth: 10
                }
            },
            title: {
                display: true,
                text: 'Evolución Mensual de Comercios',
                font: {
                    size: 16,
                    weight: 'bold'
                },
                padding: {
                    top: 10,
                    bottom: 20
                }
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                titleFont: {
                    size: 13,
                    weight: 'bold'
                },
                bodyFont: {
                    size: 12
                },
                padding: 10,
                cornerRadius: 8
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.05)',
                    drawBorder: false
                },
                title: {
                    display: true,
                    text: 'Cantidad de Comercios',
                    font: {
                        size: 12,
                        weight: 'bold'
                    }
                }
            },
            x: {
                grid: {
                    display: false
                },
                title: {
                    display: true,
                    text: 'Meses del Año',
                    font: {
                        size: 12,
                        weight: 'bold'
                    }
                }
            }
        },
        interaction: {
            mode: 'index',
            intersect: false,
        },
        elements: {
            bar: {
                borderRadius: 8,
            }
        }
    };

    return (
        <div className='w-100 m-0 p-0' style={{ position: 'relative' }}>
            {/* Contenedor para las tarjetas */}
            <div style={{ 
                position: 'sticky', 
                top: 0, 
                zIndex: 1000,
                backgroundColor: '#f8f9fa',
                width: '100%'
            }}>
                <div className='px-4 py-0'>
                    <div className="row g-4 mb-0 w-100" style={{ margin: 0 }}>
                        {cardsData.map((card, index) => (
                            <div key={index} className="col-12 col-sm-6 col-xl-3" style={{ padding: '0 0.5rem' }}>
                                <div
                                    className="card border-0 rounded-4 shadow-sm position-relative overflow-hidden"
                                    style={{
                                        background: card.color,
                                        color: 'white',
                                        transition: 'transform 0.3s, box-shadow 0.3s',
                                        borderRadius: 15,
                                        cursor: 'pointer',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                        height: '130px',
                                        marginTop: 0
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.2)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                                    }}
                                >
                                    {/* Círculo decorativo */}
                                    <div style={{
                                        position: 'absolute',
                                        top: -20,
                                        right: -20,
                                        width: 100,
                                        height: 100,
                                        borderRadius: '50%',
                                        background: 'rgba(255, 255, 255, 0.1)'
                                    }}></div>
                                    <div style={{
                                        position: 'absolute',
                                        bottom: -30,
                                        left: -30,
                                        width: 150,
                                        height: 150,
                                        borderRadius: '50%',
                                        background: 'rgba(255, 255, 255, 0.05)'
                                    }}></div>

                                    <div className="card-body p-3 h-100 d-flex align-items-center">
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <div>
                                                <span className="text-uppercase small fw-bold opacity-75" style={{ letterSpacing: '2px' }}>
                                                    {card.title}
                                                </span>
                                                <h2 className="fw-bold mb-0 mt-1" style={{ fontSize: '2rem' }}>
                                                    {card.value.toLocaleString()}
                                                </h2>
                                            </div>
                                            <i className={card.icon} style={{ color: card.iconColor, fontSize: '2rem' }}></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Contenedor para la gráfica */}
            <div className="container-fluid mt-4 px-4">
                <div className="row">
                    <div className="col-12">
                        <div className="card border-0 rounded-4 shadow-sm">
                            <div  style={{ height: '800px', position: 'relative' }} className="card-body p-4">
                               

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Grafica;